import { tokenManager } from "lib/tokenManager";
import { useSyncExternalStore } from "react";

export const useIsUserLoggedIn = () => {
    const token = useSyncExternalStore(tokenManager.subscribe, tokenManager.get);
    return token !== null;
};
